var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "475px",
    height: "512px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 475 512.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C28F60",
    d: "M0 417.58l202.44 26.17c-5.92,-16.29 -9.15,-33.86 -9.15,-52.19 0,-42.23 17.12,-80.46 44.79,-108.13 27.67,-27.66 65.9,-44.78 108.12,-44.78 42.22,0 80.46,17.12 108.13,44.78 5.83,5.84 11.19,12.15 16.02,18.85l1.39 -261.39 -299.87 -40.89 -171.87 77.98 0 339.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AA7950",
    points: "471.74,40.89 459.77,48.69 338.97,124.05 0,77.98 171.87,0 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2A06D",
    d: "M340.21 238.76l0 -112.76 131.53 -85.11 3.26 268.21c-5.96,-9.29 -12.9,-17.9 -20.67,-25.67 -27.67,-27.66 -65.91,-44.78 -108.13,-44.78 -2,0 -4,0.04 -5.99,0.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#65472F",
    points: "232.12,8.21 330.35,21.61 189.75,105.62 189.66,251.05 139.63,216.97 89.59,245.25 95.84,92.57 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4136",
    d: "M346.2 270.87c66.66,0 120.69,54.03 120.69,120.69 0,66.65 -54.03,120.68 -120.69,120.68 -66.65,0 -120.68,-54.03 -120.68,-120.68 0,-66.66 54.03,-120.69 120.68,-120.69l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D13327",
    d: "M293.97 369.34c-1.71,-1.67 -3.29,-3.12 -4.29,-4.56l0.17 0.16 24.42 24.42 -0.15 0.14 -20.15 -20.16zm107.8 -16.56l1.88 1.92c5.84,5.77 5.54,9.15 0.04,14.53l-24.39 24.38 -4.26 -4.25 24.53 -24.54c4.66,-4.55 5.59,-7.68 2.2,-12.04zm0.3 63.89l1.62 1.62c5.5,5.37 5.8,8.75 -0.04,14.53l-17.78 18.21c-5.47,5.64 -8.26,2.02 -12.7,-2.49l-24.4 -24.4 -24.55 24.55c-5.37,5.51 -8.76,5.81 -14.53,-0.03l-18.21 -17.78c-0.83,-0.81 -1.45,-1.55 -1.91,-2.25l16 15.62c5.78,5.84 9.16,5.54 14.54,0.04l24.54 -24.55 24.4 24.4c4.44,4.51 7.23,8.12 12.7,2.48l17.78 -18.21c4.77,-4.71 5.45,-7.83 2.54,-11.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M289.85 364.94c-4.51,-4.44 -8.13,-7.23 -2.49,-12.71l18.21 -17.77c5.78,-5.84 9.16,-5.55 14.53,-0.04l24.55 24.55 24.4 -24.4c4.44,-4.51 7.23,-8.13 12.7,-2.49l17.78 18.21c5.84,5.78 5.54,9.16 0.04,14.54l-24.53 24.52 24.53 24.53c5.5,5.38 5.8,8.76 -0.04,14.53l-17.78 18.21c-5.47,5.64 -8.26,2.03 -12.7,-2.48l-24.4 -24.4 -24.55 24.55c-5.37,5.5 -8.75,5.8 -14.53,-0.04l-18.21 -17.78c-5.64,-5.47 -2.02,-8.26 2.49,-12.7l24.42 -24.42 -24.42 -24.41z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.95a02a67ae871245439c3c6c8a6a934c.svg";
export { ForwardRef as ReactComponent };